import Vue from "vue";
import {defaultVersion, Version} from "./models/Version";
import {Division} from "./models/Division";
import router from "../../router";
import {createPartsFromVersionJson, createSectionsFromMainPlayableJson} from "./utils/PlayableFactory";
import {BackEndService} from "../../utils/BackEndService";
import {playablePool} from "./utils/PlayablePool";
// @ts-ignore false negative
import {processLyrics} from './utils/LyricsUtils.js'
import {TranspositionOption} from "../transposition/models/TranspositionOption";
import { playerService } from "../player/models/PlayerService";

interface SongServiceState {
  currentVersion: Version
  divisions: Division[]
  beatPractice: Division[]
}

class SongService {

  public readonly state = Vue.observable<SongServiceState>({
    currentVersion: defaultVersion,
    divisions: [new Division],
    beatPractice: [new Division],
  });

  // TODO: load only if necessary add a cache system
  public loadVersion(id: number|string, inPlayer : boolean = false): Promise<any> {
    const transposition = router.currentRoute.query.transposition;
    const forceTranspositionQuery = transposition ? `&transposition=${transposition}` : '';
    const inPlayerQuery = `?inPlayer=${inPlayer}`;
    return BackEndService.sendGetRequest(`version/${id}/sheet${inPlayerQuery}${forceTranspositionQuery}`).then((response) => {
      const json = response.content;
      /* Prepare data */
      createSectionsFromMainPlayableJson(json.model)
      createPartsFromVersionJson(json.model)
      const version = Version.createFromVersionJson(json.model);

      /* Handle Lyrics */
      if (json.model.piece.lyrics !== null) {
        processLyrics(json);
        version.processedLyricsSimple = json.processedLyricsSimple;
        version.processedLyrics = json.processedLyrics;
      }

      playablePool.add(version);

      /* State Update */
      this.state.currentVersion = version;
      this.state.divisions = Object.freeze(json.divisions);
      this.state.beatPractice = Object.freeze(json.beatPractice);

      playerService.state.playableContentType = 'version'
    });
  }

  public clearState() {
    this.state.currentVersion = defaultVersion;
    this.state.divisions = [new Division];
    this.state.beatPractice = [new Division];

    // TODO: Should we reset it here
    playablePool.reset();
  }

  /**
   * return true if we need to refresh
   * @param newTransposition
   */
  public setSelectedTransposition(newTransposition: TranspositionOption): Promise<boolean> {
    return BackEndService.sendPostRequest(`version/${this.state.currentVersion.id}/transposition`, {
      'version_transposition_id': newTransposition.id
    }).then(() => {
      const shouldRefresh = !(!this.state.currentVersion.selectedTranspositionId && newTransposition.isOriginalTone);
      this.state.currentVersion.selectedTranspositionId = newTransposition.id;
      return shouldRefresh;
    })
  }

  // TODO: Should be moved elsewhere or simplified, we don't really need this service to load pages ?
  public getUrlWithParams(page: 'player' | 'song' | 'learn' | 'lyrics-editor') {
    return`/${page}/version/${this.state.currentVersion.id}`
      +`/${this.state.currentVersion.piece.url_artist}/${this.state.currentVersion.piece.url_title}`
  }
}

export const songService: SongService = new SongService();
